export enum Fields {
  FAMILY_PRIMARY_KEY = 'familyPrimaryKey',
  LABEL = 'label',
  BUSINESS_LEVEL_ID = 'businessLevelId',
  NAME = 'name',
  LEVEL_POINTS = 'levelPoints',
  DISCOUNT = 'discount',
}
